<template>
  <b-modal v-model="show" hide-header hide-footer no-close-on-backdrop centered>
    <b-overlay :show="isLoading" variant="white">
      <h3 class="mb-4"><b-icon-key /> Створіть новий пароль</h3>
      <div class="form-input mb-3">
        <label for="">Пароль</label>
        <b-form-input type="password" placeholder="••••••" v-model="password" />
      </div>
      <div class="form-input">
        <label for="">Пароль повторно</label>
        <b-form-input
          v-model="password_confirm"
          type="password"
          placeholder="••••••"
        />
      </div>
      <div class="mt-4">
        <password
          v-model="password"
          :secureLength="6"
          :strength-meter-only="true"
        />
      </div>
      <b-button
        :disabled="password.length < 6 || !match"
        @click="updatePassword"
        variant="primary w-100"
        size="lg"
      >
        Зберегти новий пароль
      </b-button>
    </b-overlay>
  </b-modal>
</template>

<script>
import Password from "vue-password-strength-meter";
export default {
  components: { Password },
  data() {
    return {
      isLoading: false,
      show: false,
      password: "",
      password_confirm: "",
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userData() {
      return this.$store.state.userData;
    },
    match() {
      return this.password == this.password_confirm;
    },
  },
  methods: {
    updateDb() {
      this.$db.update("users", this.user.uid, { password_changed: true });
    },
    async updatePassword() {
      this.isLoading = true;
      let result = await this.$auth.updatePassword(this.password);
      console.log(result);
      if (result.result == true) {
        this.updateDb();
        this.$toast.success("Новий пароль збережено");
        this.show = false;
      }
      this.isLoading = false;
    },
  },
  mounted() {
    window.setTimeout(() => {
      if (!this.userData.password_changed) {
        this.show = true;
      }
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.form-input {
  label {
    color: var(--primary-color);
    font-size: 14px;
    margin-bottom: 5px;
  }
}
.Password {
  max-width: initial;
}
</style>
